/* eslint-disable react/no-unstable-nested-components */
import { useEffect, useRef, useState } from 'react';
import { ReactMultiEmail } from 'react-multi-email';
import { useTemplate } from '../../../../features/template/TemplateProvider';
import { ButtonPrimary } from '../../../../utils/Button';
import { CopyIcon, CrossFillIcon, ImageUploadingIcon, TickIcon } from '../../../../utils/SVGIcon';
import { GetDate } from '../../../../utils/Show';
import { handleLoadLicenseKey } from '../../SubscriptionsOperation';
import { handleSendLicenseInfoOpe } from '../SubscriptionsDetailsOpe';

function InfoRow({ title, value, action }) {
    if (action) {
        return (
            <div className="flex items-center">
                <div className="text-base text-primary-700 whitespace-nowrap w-40">
                    <span>{title}:</span>
                </div>
                <div className="text-base text-primary w-[calc(100%_-_160px)]">
                    <span>{value}</span>
                </div>
                <div className="ml-3">{action}</div>
            </div>
        );
    }

    return (
        <div className="flex items-center">
            <div className="text-base text-primary-700 whitespace-nowrap w-40">
                <span>{title}:</span>
            </div>
            <div className="text-base text-primary w-[calc(100%_-_160px)]">
                <span>{value}</span>
            </div>
        </div>
    );
}

function KeyGenerationModal({ data, closeModal }) {
    const inputRef = useRef(null);
    const { id, subscriptionName, applicationInfo, timeSubscriptionEnd, customerInfo } = data || {};
    console.log(data);
    const [keyInfo, setKeyInfo] = useState({ data: {}, loading: false });
    const [timeCount, setTimeCount] = useState(0);
    const [emailData, setEmailData] = useState([customerInfo?.primaryEmail]);
    const { setMessage, setConfirm, setTemplateLoading } = useTemplate();

    useEffect(() => {
        const interval = setInterval(() => {
            if (timeCount >= 1) {
                setTimeCount(timeCount - 1);
            }
        }, 1000);

        return () => clearInterval(interval);
    }, [timeCount]);

    const handleInputClick = () => {
        if (inputRef.current) {
            inputRef.current.select();
            document.execCommand('copy');
            setTimeCount(2);
        }
    };
    // -- Load all customer initially
    useEffect(() => {
        setKeyInfo((prevData) => ({ ...prevData, data: {}, loading: true }));
        handleLoadLicenseKey(id)
            .then(({ title, data: resData }) => {
                setKeyInfo((prevData) => ({
                    ...prevData,
                    data: resData,
                    loading: false
                }));
                setMessage({ type: 'success', text: title });
            })
            .catch((error) => {
                setKeyInfo((prevData) => ({ ...prevData, loading: false }));
                setMessage({ type: 'error', text: error?.toString(0) });
            });
    }, [setMessage, id]);

    const token = keyInfo?.data?.licenseKey || '';

    const handleSendLicenseInfo = (ev) => {
        ev.preventDefault();
        setConfirm({
            text: 'Do you want to send license info to the customer?',
            textAction: "yes, I'm sure",
            clickAction: () => {
                setTemplateLoading(true);
                handleSendLicenseInfoOpe(id, emailData)
                    .then(({ title }) => {
                        setTemplateLoading(false);
                        closeModal();
                        setConfirm(null);
                        setMessage({ type: 'success', text: title });
                    })
                    .catch((error) => {
                        setConfirm(null);
                        setTemplateLoading(false);
                        setMessage({ type: 'error', text: error?.toString(0) });
                    });
            }
        });
    };
    return (
        <div>
            <div className="flex flex-col gap-y-1 mb-4">
                <InfoRow title="Email" value={customerInfo?.primaryEmail} />
                <InfoRow title="APP ID" value={applicationInfo?.id || 0} />
                <InfoRow title="APP Name" value={applicationInfo?.applicationTitle || 0} />
                <InfoRow title="Subscription ID" value={id || 0} />
                <InfoRow title="Subscription Name" value={subscriptionName || 0} />
                <InfoRow title="Renew Date" value={GetDate(timeSubscriptionEnd) || '--'} />
            </div>

            <div className={`relative  ${token?.length === 0 ? '' : 'group'}`}>
                <textarea
                    ref={inputRef}
                    name="token"
                    cols="30"
                    rows="10"
                    readOnly
                    className="w-full h-[165px] overflow-hidden p-3 resize-none focus:outline-none rounded-10 border border-primary-200 text-lg "
                    defaultValue={token}
                    onClick={handleInputClick}
                    disabled={token?.length === 0}
                />
                <button
                    type="button"
                    className="absolute top-2 right-2 p-[6px] bg-[rgba(255,255,255,0.80)] backdrop-blur-[1px] rounded-md hidden group-hover:block w-7 h-7 text-primary"
                    onClick={handleInputClick}
                >
                    {timeCount === 0 ? <CopyIcon /> : <TickIcon />}
                </button>

                {keyInfo?.loading && (
                    <div className="absolute top-0 left-0 w-full h-full text-secondary z-50">
                        <ImageUploadingIcon />
                    </div>
                )}
            </div>
            <form className="w-full flex flex-col gap-4 my-2">
                <ReactMultiEmail
                    id="Emails"
                    className="p-2.5 rounded-10 border border-primary-200 flex flex-col justify-start gap-2 w-full [&_.data-labels]: [&_.data-labels]:!flex [&_.data-labels]:gap-1 [&_.data-labels]:!flex-wrap [&>input]:border [&>input]:border-primary-100 [&>input]:!outline-none [&>input]:p-1 [&>input]:rounded-5"
                    autoFocus={false}
                    emails={emailData}
                    onChange={(_emails) => {
                        setEmailData(_emails);
                    }}
                    getLabel={(email, index, removeEmail) => (
                        <div
                            data-tag
                            key={index}
                            className="flex justify-between items-center gap-2 bg-primary-100 p-1 px-2 rounded-5"
                        >
                            <div data-tag-item>{email}</div>
                            <button
                                type="button"
                                data-tag-handle
                                className="size-4"
                                onClick={() => removeEmail(index)}
                            >
                                <CrossFillIcon />
                            </button>
                        </div>
                    )}
                />
                <ButtonPrimary
                    title="Send License Info"
                    onClick={handleSendLicenseInfo}
                    disabled={keyInfo?.loading}
                />
            </form>
        </div>
    );
}

export default KeyGenerationModal;
